<div class="media m-t-1">
  <div class="media-body">
    <div class="p-d-flex p-jc-between">
      <div>
        <!-- Header title -->
        <app-entity-follow-header
          [name]="outlet.name"
          [active]="isOutletSaved"
          [ignored]="isOutletIgnored"
          [allowIgnore]="true"
          [labels]="shortcutLabels"
          [activeLabel]="outletLabel"
          [isLoading]="isSavingOutlet"
          [showActions]="!hideFollowing"
          (toggled)="handleSaveOutlet(outlet)"
          (ignoreToggled)="handleIgnoreOutlet($event)"
          (labelToggled)="handleOutletLabel($event)"
        ></app-entity-follow-header>
        <!-- Author associated (TODO TN-483) -->
        <ul class="nav customizer-tab p-mb-2" *ngIf="outlet?.description">
          <li>
            <div class="row">
              <!-- <div class="col">
                       <h5>
                         <a
                           href="javascript:;"
                           role="button"
                           (click)="onDisplayAuthorContent(outlet.authorId)"
                           >{{ outlet.author }}</a
                         >
                       </h5>
                     </div> -->
              <div class="col-md-auto">
                <span *ngIf="outlet?.description">
                  {{ outlet.description | slice : 0 : 250 }}
                  <span *ngIf="outlet.description.length > 250"
                    >...
                    <a
                      href="javascript:void(0)"
                      (click)="
                        $event.preventDefault();
                        $event.stopPropagation();
                        descriptionPanel.toggle($event)
                      "
                      class="read-more-link"
                      >Read more</a
                    >
                  </span>
                </span>
                <p-overlayPanel
                  #descriptionPanel
                  [style]="{ 'max-width': '400px' }"
                  styleClass="description-overlay"
                  [baseZIndex]="100000"
                  appendTo="body"
                >
                  <ng-template pTemplate="content">
                    <p style="margin: 0; white-space: pre-wrap">
                      {{ outlet.description }}
                    </p>
                  </ng-template>
                </p-overlayPanel>
              </div>
            </div>
          </li>
        </ul>
        <!-- Social media contacts -->
        <ul class="nav">
          <div class="row align-items-end">
            <li
              *ngIf="
                hasReportingAccess() && outlet.influenceScore != null
              "
            >
              <div
                class="row"
                pTooltip="Measures how likely an outlet’s coverage is to influence AI-generated answers, blending independently calibrated ChatGPT, Gemini, and Claude evaluations of authority, accessibility, retrievability, and persistence."
                tooltipZIndex="100001"
              >
                <div class="col-md-auto"></div>
                <div class="col">
                  <i class="pi pi-sitemap font-17 m-r-3"></i>
                  GEO {{ outlet.influenceScore }}%
                </div>
              </div>
            </li>
            <!--
            <li *ngIf="outlet.contact?.emailAddress">
              <div class="row">
                <div class="col-md-auto"></div>
                <div class="col">
                  <a
                    href="mailto:{{ outlet.contact?.emailAddress }}"
                    [target]="'_blank'"
                  >
                    <i class="pi pi-envelope font-17 m-r-3"></i>
                    {{ outlet.contact?.emailAddress }}
                  </a>
                </div>
              </div>
            </li>
            -->
            <li *ngIf="outlet.website">
              <div class="row">
                <div class="col-md-auto"></div>
                <div class="col">
                  <a [href]="outlet.website" [target]="'_blank'">
                    <i class="pi pi-globe font-17 m-r-3"></i>
                    Website
                  </a>
                </div>
              </div>
            </li>
            <li *ngIf="outlet.twitter && outlet.twitter != 'cbf'">
              <div class="row">
                <div class="col-md-auto"></div>
                <div class="col">
                  <a [href]="outlet.twitter" [target]="'_blank'">
                    <i class="pi pi-twitter font-17 m-r-3"></i>
                    X
                  </a>
                </div>
              </div>
            </li>
            <li *ngIf="outlet.linkedIn && outlet.linkedIn != 'cbf'">
              <div class="row">
                <div class="col-md-auto"></div>
                <div class="col">
                  <a [href]="outlet.linkedIn" [target]="'_blank'">
                    <i class="pi pi-linkedin font-17 m-r-3"></i>
                    LinkedIn
                  </a>
                </div>
              </div>
            </li>
            <li *ngIf="outlet.youTube && outlet.youTube != 'cbf'">
              <div class="row">
                <div class="col-md-auto"></div>
                <div class="col">
                  <a [href]="outlet.youTube" [target]="'_blank'">
                    <i class="pi pi-youtube font-17 m-r-3"></i>
                    YouTube
                  </a>
                </div>
              </div>
            </li>
<!--            <li *ngIf="outlet.locationUrl">-->
<!--              <div class="row">-->
<!--                <div class="col-md-auto"></div>-->
<!--                <div class="col">-->
<!--                  <a [href]="outlet?.locationUrl" [target]="'_blank'">-->
<!--                    <i class="pi pi-map-marker font-17 m-r-3"></i>-->
<!--                    {{ outlet?.location }}-->
<!--                  </a>-->
<!--                </div>-->
<!--              </div>-->
<!--            </li>-->
          </div>
        </ul>
      </div>
      <!-- Avatar image -->
      <div *ngIf="outletPicture">
        <img
          class="mt-4 mr-5 photo"
          [src]="outletPicture"
          onerror="this.parentElement.style.display='none'"
        />
      </div>
    </div>
  </div>
</div>

<hr />
<div class="content-heading">
  <div>
    <label style="font-size: large">Recent content by {{ outlet.name }}</label>
  </div>
  <div class="content-heading__action">
    <p-button
      class="p-button-sm coverage view-all-button"
      type="button"
      icon="pi pi-search"
      label="Search all content by {{ outlet.name }}"
      (click)="goToExploreRelatedCoverage(outlet)"
    ></p-button>
  </div>
</div>

<app-content-items
  [parentName]="parentName"
  [items]="contentItems"
  [loading]="!loading"
  [pageSize]="outletContentPageSize"
  [page]="currentPage"
  [total]="outletContentTotal"
  [keywords]="searchBody?.keywords"
></app-content-items>

<div id="paginator" class="p-d-flex p-jc-between">
  <div *ngIf="outletContentTotalPages >= 2">
    <p-paginator
      #pp
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ outletContentTotal | number }} total items"
      [pageLinkSize]="3"
      [showFirstLastIcon]="false"
      (onPageChange)="getPage($event)"
      [rows]="outletContentPageSize"
      [totalRecords]="outletContentTotal"
    >
    </p-paginator>
  </div>
  <div class="report-data-action">
    <p-button
      pTooltip="Report Missing Data"
      class="p-button-sm coverage report-data-button"
      icon="pi pi-flag"
      label=""
      (click)="openReportMissingDataModal()"
    ></p-button>
  </div>
  <div id="sort">
    <app-sort-options
      (sortChangesEmiter)="sortChange($event)"
      [defaultSort]="sortSelected"
    ></app-sort-options>
  </div>
</div>
